// quotation-preview Footer.js
import React from "react";
import signatures from "../../utils/signatures";
import { View, Text, Image } from "@react-pdf/renderer";
import { styles } from "../styles";

const formatNumber = (num) => {
  return parseFloat(num || 0).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const Footer = ({ quotationData, bankInfo }) => {
  // console.log("quotationData ==>", quotationData);

  const MAX_REMARK_LINES = 5;

  const renderRemarkSection = () => {
    const remarkText = quotationData.remark
      ? quotationData.remark.split("\n").slice(0, MAX_REMARK_LINES).join("\n")
      : "-";

    return (
      <View style={styles.remarkContainer}>
        <Text style={styles.remarkTitle}>Remark</Text>
        <Text style={styles.remarkText}>{remarkText}</Text>
      </View>
    );
  };

  const renderSummaryAndPaymentDetails = () => (
    <>
      {renderRemarkSection()} {/* ✅ แสดง Remark ก่อน Summary */}
      <View style={styles.summaryContainer}>
        {/* Payment Details + Bank Account Info */}
        <View style={styles.paymentDetails}>
          <Text style={{ fontWeight: "bold", marginBottom: 5 }}>
            รายละเอียดการชำระเงิน :
          </Text>
          <Text>Payment Details</Text>
          <Text>
            - ระยะเวลา Credit Term :{" "}
            {quotationData.CreditTerm === "0"
              ? "see condition"
              : `${quotationData.CreditTerm} วัน`}
          </Text>
          <View style={styles.borderLine}></View>
          {/* ✅ นำ Bank Account Details กลับมา */}
          <Text style={{ fontWeight: "bold" }}>
            You can transfer to owner account:
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>ACCOUNT OWNER : </Text>
            {bankInfo.accountOwner || "-"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>ACCOUNT NO : </Text>
            {bankInfo.accountNo || "-"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>ACCOUNT TYPE : </Text>
            {bankInfo.accountType || "-"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>BANK NAME : </Text>
            {bankInfo.bankName || "-"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>BRANCH NAME : </Text>
            {bankInfo.branchName || "-"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>BANK ADDRESS : </Text>
            {bankInfo.bankAddress || "-"}
          </Text>
          <Text>
            <Text style={{ fontWeight: "bold" }}>SWIFT CODE : </Text>
            {bankInfo.swiftCode || "-"}
          </Text>
        </View>

        {/* ✅ ฝั่งขวา (Summary Fields) */}
        <View style={styles.summary}>
          <View style={styles.summaryRow}>
            <Text>Total Before Fee:</Text>
            <Text>{formatNumber(quotationData.totalBeforeFee)}</Text>
          </View>
          <View style={styles.summaryRow}>
            <Text>Fee ({quotationData.fee}%):</Text>
            <Text>
              {formatNumber(
                quotationData.totalBeforeFee * (quotationData.fee / 100)
              )}
            </Text>
          </View>
          <View style={styles.summaryRow}>
            <Text>Total:</Text>
            <Text>{formatNumber(quotationData.total)}</Text>
          </View>
          <View style={styles.summaryRow}>
            <Text>Discount:</Text>
            <Text>{formatNumber(quotationData.discount)}</Text>
          </View>
          <View style={styles.summaryRow}>
            <Text>Amount Before Tax:</Text>
            <Text>{formatNumber(quotationData.amountBeforeTax)}</Text>
          </View>
          <View style={styles.summaryRow}>
            <Text>VAT (7%):</Text>
            <Text>{formatNumber(quotationData.vat)}</Text>
          </View>
          <View style={styles.summaryRowLast}>
            <Text>Net Amount:</Text>
            <Text>{formatNumber(quotationData.netAmount)}</Text>
          </View>
        </View>
      </View>
    </>
  );

  const renderSignature = () => {
    const approvedEmails =
      quotationData?.approvalHierarchy?.[0]?.approvalHierarchy
        ?.filter((entry) => entry.status === "Approved")
        .map((entry) => entry.approver) || [];

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const company = user.company?.toUpperCase() || "";

    const createdByEmail =
      company === "OPTX" ? "chawachai@optx.co.th" : "natorn@neonworks.co.th";

    const proposedByEmail =
      company === "OPTX" ? "chawachai@optx.co.th" : "akedanai@neonworks.co.th";

    const getSignatureBlock = (roleLabel, name, email) => (
      <View style={styles.signatureBlock}>
        {/* เส้นลายเซ็น */}
        <View style={{ position: "relative", height: 50, marginBottom: 4 }}>
          <View
            style={{
              position: "absolute",
              bottom: 0,
              width: "100%",
              height: 1,
              backgroundColor: "#000", // เส้นดำ 1px
            }}
          />
          {/* ลายเซ็นซ้อนบนเส้น */}
          {approvedEmails.includes(email) && signatures[email] && (
            <Image
              style={{
                position: "absolute",
                bottom: 1,
                left: "50%",
                transform: "translateX(-50%)",
                width: 80,
                height: 40,
              }}
              src={signatures[email]}
            />
          )}
        </View>

        <Text style={{ fontWeight: "bold" }}>{roleLabel}</Text>
        <Text style={{ marginTop: 6, textAlign: "center" }}>
          ({name || "____________________________________"})
        </Text>
        <Text style={{ marginTop: 8 }}>
          วันที่/Date ............./............./.............
        </Text>
      </View>
    );

    return (
      <View style={styles.signatureSection}>
        {getSignatureBlock(
          "Customer",
          quotationData.clientDetails?.companyBaseName,
          "" // ไม่มีลายเซ็นอัตโนมัติ
        )}
        {getSignatureBlock(
          "Created by",
          quotationData.createBy,
          createdByEmail
        )}
        {getSignatureBlock(
          "Proposed by",
          quotationData.proposedBy,
          proposedByEmail
        )}
      </View>
    );
  };

  return (
    <View>
      {renderSummaryAndPaymentDetails()}
      {renderSignature()}
    </View>
  );
};

export default Footer;
